export default __webpack_public_path__ + "static/Color_Member_Logo-210aaa45fb4168d6e928ae1b0095c4fc.jpg";